import React from 'react';

export default function ScanOverlay() {
  return (
    <div className="pointer-events-none fixed inset-0 z-[60]">
      {/* Vignette */}
      <div className="absolute inset-0" style={{
        background: 'radial-gradient(ellipse at center, transparent 50%, rgba(0,0,0,0.6) 100%)',
      }} />
      {/* Scan line */}
      <div className="absolute left-0 right-0 h-[120px] scan-line" style={{
        background: 'linear-gradient(180deg, transparent 0%, rgba(0,212,255,0.06) 50%, transparent 100%)',
      }} />
      {/* Noise */}
      <div className="absolute inset-0 bg-noise" />
      {/* Corner brackets */}
      <div className="absolute top-20 left-3 w-6 h-6 border-t border-l border-cyan-400/50" />
      <div className="absolute top-20 right-3 w-6 h-6 border-t border-r border-cyan-400/50" />
      <div className="absolute bottom-3 left-3 w-6 h-6 border-b border-l border-cyan-400/50" />
      <div className="absolute bottom-3 right-3 w-6 h-6 border-b border-r border-cyan-400/50" />
    </div>
  );
}
